const initialState = [];

export default initialState;